// 사장님창구랜딩페이지
//route/promotion?=20221013-cofficturesEvent

import React, { useEffect } from 'react';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import '../../assets/css/font.css';

// IMG
import CeoLandingBanner from "../../assets/img/landing/coffeBanner.png";
import CeoLanding01 from "../../assets/img/landing/m_ceoLanding01.png";
import CeoLanding02 from "../../assets/img/landing/m_ceoLanding02.png";
import CeoLanding03 from "../../assets/img/landing/m_ceoLanding03.png";
import CeoLanding04 from "../../assets/img/landing/firstcoffee02.png";
import CeoLanding05 from "../../assets/img/landing/firstcoffee03.png";
import review01 from "../../assets/img/landing/review01.png";
import review04 from "../../assets/img/landing/review04.png";
import review03 from "../../assets/img/landing/review03.png";
import CeoLanding06 from "../../assets/img/landing/m_ceoLanding06.png";
import CeoLandingstore01 from "../../assets/img/landing/m_ceoLadingStore01.png";
import CeoLandingstore02 from "../../assets/img/landing/m_ceoLadingStore02.png";
import moreBtn from "../../assets/img/landing/m_openEventButton.png";


const Content = (oProps) => {

    useEffect(() => {
        setTimeout(() => {
            oProps.fSetDocumentTitle("커픽쳐스 사장님 이벤트");
        }, 150);

        window.scrollSection();
        window.scrollPoint();
    })


    return (
        <LandingStyle>
            <div className="ceoLandingPage">
                <div className="banner">
                    <img src={CeoLandingBanner} alt="스루소개이미지" width="100%" />
                </div>
                <img src={CeoLanding01} alt="스루소개이미지" width="100%" />
                <img src={CeoLanding02} alt="스루소개이미지" width="100%" />
                <img src={CeoLanding03} alt="스루소개이미지" width="100%" />
                <img src={CeoLanding04} alt="스루소개이미지" width="100%" />
                <div className="ceoLandingPartner">
                    <h2>전국 많은 매장들이<br />스루를 이용하고 있어요.</h2>
                    <div className="logo-slider-top">
                        <div>
                            <img src={CeoLandingstore01} alt="스루 가입 매장" width="100%" />
                        </div>
                    </div>
                    <div className="logo-slider-bottoom">
                        <div>
                            <img src={CeoLandingstore02} alt="스루 가입 매장" />
                        </div>
                    </div>
                    <div className="review">
                        <div className="container">
                            <div className="partnerReview">
                                <img src={review04} alt="스루사장님후기" width="100%" />
                                <img src={review01} alt="스루사장님후기" width="100%" />
                                <img src={review03} alt="스루사장님후기" width="100%" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="promotion">
                    <img src={CeoLanding05} alt="사장님 프로모션" width="100%" />
                </div>
                <div className="joinThroo">
                    <h2>입점하고 혜택받기</h2>
                    <p>(반값쿠폰, 옥외 x배너, 앱 내 배너 광고)</p>
                    <p>*입점 대행 신청시 ‘매장명+커픽쳐스’로 작성해주세요.*</p>
                </div>
                <div className="floating">
                    <div className="container">
                        <button>
                            <a href="https://throo.page.link/CpEv" style={{ color: '#000', fontWeight: '700', fontSize: "18px" }}>혜택받고 입점하기</a>
                        </button>
                    </div>
                </div>
            </div>
        </LandingStyle>
    )
}

export default Content;

export const LandingStyle = styled.div`
.floating 
    /* 텍스트 애니메이션 */
    .in_view {
        opacity: 1;
        transition: all 1s ease-in-out;
    }
    .fade_in {
        opacity: 0;
        transform: translate3d(0, 0, 0);
    }
    .fade_up {
        opacity: 0;
        transform: translate3d(0, 15%, 0);
    }
    .in_view.fade_in,
    .in_view.fade_up {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    /* landingPageCss */
    *{
        width: 100%;
        margin: 0 auto;
        padding: 0; 
        box-sizing: border-box;
        font-family: 'Pretendard';
        font-weight: 700;
    }
    .container {
        padding: 0 5vw;
        margin: 0 auto;
    }
    .banner {
        position: relative;

        .bannerImg {
            min-height: 100vh; 
            max-height: 100vh; 
        }
        .title {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items:center;
            
            h2 {
                margin: 98px 0 25px 0;
                font-size: 25px;
                font-weight: 600;
                line-height: 30px;
                color: #fff;
            }
            .throoLogo {
                max-width: 30%;
                width: 100%;
                margin-bottom: 80px;
                text-align: center;
            }
            .bannerText {
                width: 85%;
                margin-top: 20px;
            }
        }
    }

    /* ceoLandingPartner */
    .ceoLandingPartner {
        width: 100%;
        padding: 60px 0;
        background: #000000;
        min-height: 800px;

        h2 {
            color: #fff;
            font-size: 25px;
            font-weight: 700;
            line-height: 30px;
            text-align: center;
        }
    }
    
    .review {
        .partnerReview {
            display: flex;
            overflow: auto;
            margin-top: 50px;

            img {
                width: 100%;
                max-width: 254px;
                margin-right: 28px;
            }
        }
    }

    .logo-slider-top, .logo-slider-bottoom {
        overflow: hidden;
        width: 100%;
        margin: 0 auto;
        margin-top: 40px;
        margin-bottom: 40px;
        position: relative;
        display: flex; 
        justify-content: space-between; 
    }
    .logo-slider-top div {
        display: flex;
        position: relative;
        animation: marquee 50s linear infinite;
        margin-right: 180px;
    }
    .logo-slider-bottoom div {
        display: flex;
        animation: marquee 50s linear infinite;
        animation-direction: reverse;
        margin-right: 30px;
    }
    .logo-slider-top img, .logo-slider-bottoom img {
        display: block;
        margin: 0 10px;
        width: 3008px;
        height: 70px;
    }


    @keyframes marquee {
        0% {
            transform: translateX(0%);
        }
        100% {
            transform: translateX(-100%);
        }
    }


    /* promotion */
    .promotion {
        position: relative;
       
        button {
            position: absolute;
            bottom: 23.5%;
            left: 0;
            right: 0;
            max-width: 190px;
            border: none;
            outline: none;
            
            background: none;
            margin-bottom: 50px;
        }
    }

    /* joinThroo */
    .joinThroo  {
        background: #91856F;
        padding: 40px 0 120px 0;

        h2 {
            text-align: center;
            color: #fff;
            font-size: 25px;
            font-weight: 600;
            line-height: 30px;
        }
        p {
            margin-top:5px;
            font-size: 11px;
            font-weight: 500;
            color: #F1F0ED;
            text-align: center;
        }
    }

    /* floating */
    .floating {
        position: fixed;
        bottom: 0;
        right: 0;
        left: 0;
        margin-bottom: 40px;
        max-height: 56px;
        width: 100%;

        button {
            padding: 20px 0;
            background: #FAE100;
            color: #000;
            font-size: 16px;
            font-weight: 600;
            border: none;
            outline: none;
            border-radius: 28px;
        }
    }

   
`